import * as React from "react";
const SvgArrowLeftinline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.08 16.12l-1.34 1.36L6 11.74 11.74 6l1.34 1.34-3.48 3.44h8.82v1.92h-8.8l3.46 3.42z", fill: "currentColor" }));
export default SvgArrowLeftinline;
